import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const CreateEditDutyHourTypesSkeleton = () => {
  return (
    <>
      <SectionSkeleton />
      <SectionSkeleton height={500} width={200} />
      <SectionSkeleton width={150} />
    </>
  );
};
